// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__Lc-SQ","btnWhite":"button_btnWhite__m6iWy"};